import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "inventory/uom";

const Model = {
	namespace: "m_InventoryUOM",
	state: {
		InventoryUOM: [],
	},
	reducers: {
		updateModelState(state, { payload: { response } }) {
			return { ...state, InventoryUOM: response };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// The variable name response will be passed on to payload later
			const response = yield call(svc_fetchAll, endpointBasePrefix);
			// if response was not a success code, exit and don't update anything.
			if (!showServerResponse(response, false)) return;

			_.forEach(response, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "updateModelState",
				payload: { response },
			});
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload, payload.company_name);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {
		// setup({ dispatch, history }) {
		// 	return history.listen(({ pathname, query }) => {
		// 		if (pathname === "/menu" || pathname === "/brands") {
		// 			dispatch({ type: "fetchAll", payload: query });
		// 		}
		// 	});
		// },
	},
};

export default Model;
